const isErrorLikeRecord = (
  error: unknown
): error is { name?: unknown; message?: unknown; code?: unknown } =>
  typeof error === 'object' && error !== null

export const getErrorMessage = (error: unknown): string => {
  if (error instanceof Error) return error.message
  if (isErrorLikeRecord(error) && typeof error.message === 'string') return error.message
  return String(error)
}

export const getErrorName = (error: unknown): string => {
  if (error instanceof Error) return error.name
  if (isErrorLikeRecord(error) && typeof error.name === 'string') return error.name
  return typeof error
}

export const getErrorCode = (error: unknown): string | number | null => {
  if (!isErrorLikeRecord(error)) return null
  return typeof error.code === 'string' || typeof error.code === 'number' ? error.code : null
}
